import {
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_BID_DUE_DATE_SET,
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_ADD,
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_REMOVE,
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_SET,
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_CLOSE,
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_SHOW,
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_GO_BACK,
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_SHOW,
  WORK_ORDERS_DETAILS_QUOTES_REQUEST_SUBMIT_SUCCESS,
} from '../action-types';
import { tasksApi } from '../../../../services/api/tasks-api';
import { updateTask, updateTaskSuccess } from '../work-orders';
import { showErrorMessage } from '../../../messages';
import { loadQuotesRequest, updateCurrentTask } from './details';
import { contractorsApi } from '../../../../services/api/contractors-api';
import { loadTasksFromWorkOrderRequest } from 'actions/admin/work-orders/details/details';

export function addContractor(selectedContractor) {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_ADD,
    payload: selectedContractor,
  };
}

export function goBack() {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_GO_BACK,
  };
}

export function removeContractor(index) {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_REMOVE,
    payload: index,
  };
}

export function selectContractor(option) {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_CONTRACTOR_SET,
    payload: option,
  };
}

export function setBidDueDate(date) {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_BID_DUE_DATE_SET,
    payload: date,
  };
}

export function showPreview() {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_PREVIEW_SHOW,
  };
}

export function submitQuotesRequestStart(
  taskId,
  selectedContractors,
  bidDueDate
) {
  return (dispatch) => {
    return tasksApi
      .addQuoteRequest(
        taskId,
        selectedContractors.map((element) => {
          return element.value;
        }),
        bidDueDate
      )
      .then((response) => {
        if (response.ok) {
          dispatch(submitQuotesRequestSuccess());
          dispatch(updateTaskSuccess());
          dispatch(updateTask(response.task));
          dispatch(updateCurrentTask(response.task));
          dispatch(loadQuotesRequest(response.task.work_order_id));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function submitMultipleQuotesRequestStart(
  workOrderId,
  taskIds,
  contractorId,
  bidDueDate
) {
  return (dispatch) => {
    return contractorsApi
      .addQuoteRequest(workOrderId, taskIds, contractorId, bidDueDate)
      .then((response) => {
        if (response.ok) {
          dispatch(submitQuotesRequestSuccess());
          dispatch(loadTasksFromWorkOrderRequest(workOrderId, false));
          dispatch(loadQuotesRequest(workOrderId));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function submitQuotesRequestSuccess() {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_SUBMIT_SUCCESS,
  };
}

export function showQuotesRequestModalRequest(
  propietarySubContractors,
  tradeIds
) {
  return (dispatch) => {
    return contractorsApi.getContractors(tradeIds).then((response) => {
      if (response.ok) {
        // Form the WO preselected contractors, filter the ones that are not related with the current trade.
        const contractorsIdForTrade = response.contractors.map(
          (contractor) => contractor.id
        );
        dispatch(
          showQuotesRequestModal(
            propietarySubContractors.filter(
              (propietary) =>
                contractorsIdForTrade.indexOf(propietary.id) !== -1
            )
          )
        );
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function showQuotesRequestModal(propietarySubContractors) {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_SHOW,
    payload: propietarySubContractors.map((element) => {
      return {
        value: element.id,
        label: element.name,
      };
    }),
  };
}

export function closeQuotesRequestModal() {
  return {
    type: WORK_ORDERS_DETAILS_QUOTES_REQUEST_MODAL_CLOSE,
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/work-orders/details/quotes-request.js